<template>
  <div class="chat-window" :class="{ '-minimize': mini }">
    <div class="chat-window-content">
      <div class="chat-window__head">
        <div class="chat-window__head__icon"></div>
        <div class="chat-window__head__title">Puanla</div>
        <div class="chat-window__head__buttons">
          <div class="chat-window__head__buttons__minimize" @click="minimize()"></div>
          <div class="chat-window__head__buttons__end" @click="closeChat()">Sonlandır</div>
        </div>
      </div>
      <div class="chat-window__content">
        <div class="chat-rating">
          <div class="chat-rating__title">Görüşmemiz Sonlandırıldı</div>
          <div class="chat-rating__description">Müşteri temsilcimiz ile yaptığınız görüşme ile ilgili memnuniyet düzeyinizi lütfen belirtiniz.</div>
          <div class="chat-rating__rating">
            <div class="chat-rating__rating__box">
              <div class="chat-rating__rating__emoji -one" @click="rate()"></div>
              <div class="chat-rating__rating__text">Hiç beğenmedim</div>
            </div>
            <div class="chat-rating__rating__box">
              <div class="chat-rating__rating__emoji -two" @click="rate()"></div>
              <div class="chat-rating__rating__text">Beğenmedim</div>
            </div>
            <div class="chat-rating__rating__box">
              <div class="chat-rating__rating__emoji -three" @click="rate()"></div>
              <div class="chat-rating__rating__text">Fena değil</div>
            </div>
            <div class="chat-rating__rating__box">
              <div class="chat-rating__rating__emoji -four" @click="rate()"></div>
              <div class="chat-rating__rating__text">Beğendim</div>
            </div>
            <div class="chat-rating__rating__box">
              <div class="chat-rating__rating__emoji -five" @click="rate()"></div>
              <div class="chat-rating__rating__text">Çok beğendim</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    step: {
      type: Number,
      default: 1
    },
    form: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      mini: false
    }
  },
  methods: {
    closeChat: function () {
      this.$emit('changeStep', 1)
    },
    minimize: function () {
      this.mini = !this.mini
    },
    rate: function () {
      this.$emit('changeStep', 5)
    }
  }
}
</script>